import { Callback } from "game-common/models"

import { HudChip } from "./hud_chip"

// The stand-in the ember minimap leaves behind when it is collapsed: a small pill in the top-right
// corner of the screen naming what is hiding there. It has to be conspicuous enough that a player who
// collapsed the map ten minutes ago still knows the map exists, and small enough that leaving it
// collapsed is a real choice rather than a trade of one piece of clutter for another -- hence a
// one-word label next to the glyph rather than an instruction.
//
// The plate, the sizing and the tap target all come from HudChip, which the items toggle beside it
// shares, so the row reads as one set of controls.
export class EmberMinimapChip extends HudChip {
    constructor(onClick: Callback) {
        super({ glyph: "🗺", label: "MAP", onClick })
    }
}
